import { Injectable } from '@angular/core';
import { Booking } from '../booking';
import { BrugesVndBooking } from '../bruges-vnd-booking';
import { HttpService } from '../service/http.service';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Language } from '../language';
import { ProgrammeInformation } from '../programme-information';
import { BookingStatus } from '../booking-status';
import { SimpleBookingPreConfirmation } from '../simple-booking-pre-confirmation';
import { BookingReport } from '../booking-report';
import { BookingFileType } from '../booking-file-type';
import { CKEDITORBOOKINGEMAILCONFIG, CKEDITORCONFIG, CKEDITORCONFIGMINIMAL, CKEDITORCONFIG_BOOKING_CONFIRMATION, CKEDITOR_A4_CONFIG } from '../ckeditor-config';
import { BookingConfirmation } from '../booking-confirmation';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { BookingFinalConfirmation } from '../booking-final-confirmation';
import { BookingDocumentTemplate } from '../booking-document-template';

import { Moment } from 'moment';
import { Country } from '../country';
import { MotherLanguage } from '../mother-language';
import { Gender } from '../gender';
import { TravelType } from '../travel-type';
import { TransferType } from '../transfer-type';
import { TransportType } from '../transport-type';
import { TargetLanguageLevel } from '../target-language-level';
import { LanguageCourse } from '../language-course';
import { Currency } from '../currency';
import { PaymentType } from '../payment-type';
import { ProgrammeType } from '../programme-type';
import { InsuranceSupplier } from '../insurance-supplier';
import { InternalBookingComment } from '../internal-booking-comment';
import { BookingEmailHistory } from '../booking-email-history';
import { UserForBackend } from '../user-for-backend';
import { SelectItem } from 'primeng/api';
import { School } from '../school';

@Injectable({
  providedIn: 'root'
})
export class BookingService {

  public booking!: Booking | BrugesVndBooking;
  public hasVademecum: boolean = false;
  public loadingStudentPicture: boolean = false;
  public languages: Language[] = [];
  public programmeInformations: ProgrammeInformation[] = [];
  public bookingStatuses: BookingStatus[] = [];
  public selectedBookingStatus!: BookingStatus;
  public preConfirmations: SimpleBookingPreConfirmation[] = [];
  public bookingReports: BookingReport[] = [];
  public bookingFileTypes: BookingFileType[] = [];
  public pdfTemplates: BookingDocumentTemplate[] = [];
  public bookingConfirmations!: BookingConfirmation[];
  public bookingFinalConfirmations!: BookingFinalConfirmation[];
  public bookingForm!: FormGroup;
  public travelRequestCodes: SelectItem[] = [];
  public isBookingReady = false;
  activeInternalBookingCommentEdit = false;
  selectedBookingComment!: InternalBookingComment | null;
  public internalCommentForm!: FormGroup;
  public bookingRequestComment!: string;

  countryList: Country[] = [];
  allCountries: Country[] = [];
  public genders: Gender[] = [];
  nationalities: Country[] = [];
  schoolList: School[] = [];
  paymentTypes: PaymentType[] = [];
  languageCourseList: LanguageCourse[] = [];
  motherLanguages: MotherLanguage[] = [];
  targetLanguageLevels: TargetLanguageLevel[] = [];
  // duration: number;
  yearRange = "";
  googleSheetPriceUrl: string | null = null;
  defaultDateTime = moment().startOf("hour").toDate();
  responseList = [
    { label: "No preference", value: null },
    { label: "Yes", value: true },
    { label: "No", value: false }
  ];
  currencies: Currency[] = [];

  travelTypes: TravelType[] = [];
  transferTypes: TransferType[] = [];
  transportTypes: TransportType[] = [];
  programmeTypes: ProgrammeType[] = [];
  languageLevels: TargetLanguageLevel[] = [];
  travelInsuranceSuppliers: InsuranceSupplier[] = [];
  cancellationInsuranceSuppliers: InsuranceSupplier[] = [];

  editorConfig = CKEDITORCONFIGMINIMAL;
  descriptionEditorConfig = CKEDITORCONFIG_BOOKING_CONFIRMATION;
  emailEditorConfig = CKEDITORBOOKINGEMAILCONFIG;
  a4EditorConfig = CKEDITOR_A4_CONFIG;
  emailHistories: BookingEmailHistory[] = [];
  displayMailHistoryDetail = false;
  selectedEmailHistory!: BookingEmailHistory;
  user!: UserForBackend;
  public sendingUpdateRequest = false;

  public isBrugesVndBooking = false;

  constructor(
    private httpService: HttpService,
    private builder: FormBuilder
  ) {}

  checkBookingBrugesOrVnd(){
    if(this.booking.school && (this.booking.school.id == 25 || this.booking.school.id == 75)){
      this.isBrugesVndBooking = true;
    } else {
      this.isBrugesVndBooking = false;
    }
  }

  calculateAgeAtStartDate() {
    if (this.bookingForm.value.startDate && this.booking.student.birthDay) {
      let startDate = moment(this.bookingForm.value.startDate);
      let birthDate = moment(this.booking.student.birthDay);
      this.booking.ageAtStartDate = startDate.diff(birthDate, "years");
    }
  }

  bookingToBrugesVndBooking(booking: Booking): BrugesVndBooking{
    let brugesVndBooking = new BrugesVndBooking(
      booking.startDate,
      booking.endDate,
      booking.isActive,
      booking.school,
      booking.preConfirmation,
      booking.destination,
      booking.languageCourse,
      booking.commentToSchool,
      booking.internalCommentList,
      booking.targetLanguageLevel,
      booking.accommodation,
      booking.travels,
      booking.student,
      booking.sentToSchool,
      booking.schoolConfirmed,
      booking.preConfirmationSent,
      booking.insuranceSent,
      booking.salesAgent,
      booking.quotationList,
      booking.transferType,
      booking.enableAccommodationDates,
      booking.courseComment,
      booking.activitiesComment,
      booking.excursionDate,
      booking.promoCode,
      booking.highSchoolMeetingDate,
      booking.highSchoolTestScore,
      booking.flightRequested,
      booking.cancellationInsuranceRequested,
      booking.travelInsuranceRequested,
      booking.depositReceived,
      booking.completePaymentReceived,
      booking.accommodationSent,
      booking.travelInformationSent,
      booking.flightBookedDate,
      booking.visaInformationSent,
      booking.finalConfirmationSent,
      booking.bookingConfirmed,
      booking.travelRequestCode,
      booking.emergencyTransferPhoneNumber,
      booking.travelInsuranceSupplier,
      booking.cancellationInsuranceSupplier,
      booking.emergencyTransferContact,
      booking.versionId,
      booking.reminderDate,
      booking.withPartena,
      booking.uuid,
      booking.id,
      booking.duration,
      booking.downloading,
      booking.createdBy,
      booking.created
    );
    brugesVndBooking.lvmsId = booking.lvmsId;
    return brugesVndBooking;
  }

  addBrugesInfo(brugesVndBooking: BrugesVndBooking): Observable<void[]> {
    let pictureBlob$ = this.httpService.getStudentPictureByUuid(brugesVndBooking.uuid!).pipe(map(
      picture => {
        brugesVndBooking.studentPicture = picture;
      }
    ));
    let vademecum$ = this.httpService.getVademecumByBookingId(brugesVndBooking.id!).pipe(map(
      vad => {
        brugesVndBooking.vademecum = vad;
      }
    ));
    let observableArray = [pictureBlob$, vademecum$];
    return forkJoin(observableArray);
  }

  updateProgrammeInformationList(schoolId: number, studentLanguage: Language){
    this.httpService.getProgrammeInformationsBySchoolAndLanguage(schoolId, studentLanguage.id).subscribe(res => {
      this.programmeInformations = res;
    });
  }

  public get travelForms(): FormArray{
    return this.bookingForm.get('travels') as FormArray;
  }

  updateCompletePaymentDate(){
    this.httpService.getCompletePaymentDate(this.booking.id!).subscribe(res => {
      if(res){
        this.bookingForm.get("completePaymentReceived")!.setValue(new Date(res));
      }
    });
  }

  updateBookingForm(){
    let booking = this.booking;
    this.bookingForm = this.builder.group({
      firstName: [booking.student.firstName, Validators.required],
      lastName: [booking.student.lastName, Validators.required],
      startDate: [moment(booking.startDate).toDate(), Validators.required],
      endDate: [moment(booking.endDate).toDate(), Validators.required],
      school: [booking.school, Validators.required],
      destination: booking.destination,
      languageCourse: booking.languageCourse,
      commentToSchool: booking.commentToSchool,
      internalComment: null,
      targetLanguageLevel: booking.targetLanguageLevel,
      transferType: booking.transferType,
      travels: this.builder.array([]),
      programmeType: booking.programmeType,
      courseComment: booking.courseComment,
      activitiesComment: booking.activitiesComment,
      excursionDate: booking.excursionDate == null ? null : booking.excursionDate.toDate(),
      promoCode: booking.promoCode,
      highSchoolMeetingDate: booking.highSchoolMeetingDate ? moment(booking.highSchoolMeetingDate).toDate() : null,
      highSchoolTestScore: booking.highSchoolTestScore,
      cancellationInsuranceRequested: booking.cancellationInsuranceRequested,
      flightRequested: booking.flightRequested,
      travelInsuranceRequested: booking.travelInsuranceRequested,
      depositReceived: booking.depositReceived == null ? null : moment(booking.depositReceived).toDate(),
      completePaymentReceived: booking.completePaymentReceived == null ? null : moment(booking.completePaymentReceived).toDate(),
      accommodationSent: booking.accommodationSent == null ? null : moment(booking.accommodationSent).toDate(),
      travelInformationSent: booking.travelInformationSent == null ? null : moment(booking.travelInformationSent).toDate(),
      flightBookedDate: booking.flightBookedDate == null? null: moment(booking.flightBookedDate).toDate(),
      visaInformationSent: booking.visaInformationSent == null ? null : moment(booking.visaInformationSent).toDate(),
      finalConfirmationSent: booking.finalConfirmationSent == null ? null : moment(booking.finalConfirmationSent).toDate(),
      sentToSchool: booking.sentToSchool == null ? null : booking.sentToSchool.toDate(),
      schoolConfirmed: booking.schoolConfirmed == null ? null : booking.schoolConfirmed.toDate(),
      preConfirmationSent: booking.preConfirmationSent == null ? null : booking.preConfirmationSent.toDate(),
      insuranceSent: booking.insuranceSent == null ? null : booking.insuranceSent.toDate(),
      bookingConfirmed: booking.bookingConfirmed == null? null: moment(booking.bookingConfirmed).toDate(),
      travelRequestCode: booking.travelRequestCode,
      emergencyTransferPhoneNumber: booking.emergencyTransferPhoneNumber,
      emergencyTransferContact: booking.emergencyTransferContact,
      travelInsuranceSupplier: booking.travelInsuranceSupplier,
      cancellationInsuranceSupplier: booking.cancellationInsuranceSupplier,
      cancellationInsuranceSubscriptionDate: booking.cancellationInsuranceSubscriptionDate == null?null: moment(booking.cancellationInsuranceSubscriptionDate).toDate(),
      reminderDate: booking.reminderDate == null? null: moment(booking.reminderDate).toDate(),
      withPartena: booking.withPartena
    });
  }

  setDepositReceived(date: Moment){
    this.booking.depositReceived = date;
    this.bookingForm.get("depositReceived")!.setValue(date.toDate());
  }

  activateInternalCommentEditDialog(comment: InternalBookingComment){
    this.activeInternalBookingCommentEdit = true;
    this.selectedBookingComment = comment;
    this.internalCommentForm = this.builder.group({
      body: [comment.body, Validators.required]
    });
  }
}